// extracted by mini-css-extract-plugin
module.exports = {"title":"style_title__31rgl","rows":"style_rows__1mH1r","row":"style_row__2qcqG","embeddedForms":"style_embeddedForms__1qoGk"};